// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"4bcf37e9","318":"bb2e4dfd"}[chunkId] + ".chunk.js";
};